import type { UserProfile } from '../services/firestore';
import { workspaceService } from '../services/workspaceService';
import { needsShopifyInstallWizard } from './shopifyComplianceOnboarding';
import { readShopifyInstallWizardState } from './shopifyInstallWizardStorage';
import { getInstallWizardResumePath } from './shopifyInstallWizardResume';

/** Build redirect path for in-progress Shopify App Store install wizard. */
export async function resolveShopifyInstallWizardRedirect(
  uid: string,
  profile: UserProfile | null
): Promise<string> {
  const workspaces = await workspaceService.getUserWorkspaces(uid);
  const state = readShopifyInstallWizardState();

  return getInstallWizardResumePath({
    profile,
    wizardState: state,
    needsWorkspacePicker: workspaces.length > 1 && !state?.workspaceId,
    isAuthenticated: true,
  });
}
